import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {VehicleEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconEdit, IconTrash} from "@tabler/icons-react";

export type VehicleAction = "EDIT" | "DELETE"

export type VehicleActionMenuDropdownProps = {
  vehicle: VehicleEntity
  onActionClick?: (action: VehicleAction) => void
}

export const VehicleActionMenuDropdown = (props: VehicleActionMenuDropdownProps) => {
  const {vehicle, onActionClick} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<VehicleAction> = useMemo(() => {
    const actions = new Set<VehicleAction>()
    if (hasAccess("vehicle_edit")) {
      actions.add("EDIT")
    }
    if (hasAccess("vehicle_delete")) {
      actions.add("DELETE")
    }
    return actions
  }, [vehicle, hasAccess])

  const _onActionClick = useCallback((action: VehicleAction) => {
    if (onActionClick) {
      onActionClick(action)
    }
  }, [onActionClick])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {actions.has("EDIT") &&
        <Menu.Item
          onClick={() => _onActionClick("EDIT")}
          icon={<IconEdit size={14}/>}>
          {t("common.action.edit", "Edit")}
        </Menu.Item>
      }
      {actions.has("DELETE") &&
        <>
          {actions.size > 1 && <Menu.Divider/>}
          <Menu.Item
            onClick={() => _onActionClick("DELETE")}
            icon={<IconTrash size={14}/>}
            color="red">
            {t("common.action.delete", "Delete")}
          </Menu.Item>
        </>
      }
    </>
  )
}
